import { createReducer, on } from '@ngrx/store';
import { cargaAcuerdo, cargaAcuerdoCampos, resetAcuerdo } from './actions';
import { iAcuerdo, mAcuerdo } from '../../entrada/entrada.interface';

export const initialState: iAcuerdo = mAcuerdo;

export const acuerdoReducer = createReducer(
    initialState,
    on(cargaAcuerdo, (state,  payload) => {
        return { ...state, ...payload.oAcuerdo }
    }),
    on(cargaAcuerdoCampos, (state,  payload) => {
        return { 
            ...state, 
            ...payload.oData
        };
    }),
    on(resetAcuerdo, (state,  payload) => {
        return initialState
    })
);